import { render, staticRenderFns } from "./FlowsTable.vue?vue&type=template&id=d4ba049c&scoped=true"
import script from "./FlowsTable.vue?vue&type=script&lang=js"
export * from "./FlowsTable.vue?vue&type=script&lang=js"
import style0 from "./FlowsTable.vue?vue&type=style&index=0&id=d4ba049c&prod&lang=css"
import style1 from "./FlowsTable.vue?vue&type=style&index=1&id=d4ba049c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ba049c",
  null
  
)

export default component.exports